import { Component, computed, input } from "@angular/core";

@Component({
  selector: "loading-spinner",
  imports: [],
  templateUrl: "loading-spinner.component.html",
  styleUrls: ["loading-spinner.component.scss"]
})
export class LoadingSpinnerComponent {
  isWaitingForSearchResults = input.required<boolean>();
  variant = input<string>("default");

  isDefaultVariant = computed(() => this.variant() === "default");
}
